import { Select } from '@folio/stripes/components';
import React from 'react';
import { useIntl } from 'react-intl';
import RowType from './RowType';
export default function OpenClosedSelect(_a) {
    var value = _a.value, onBlur = _a.onBlur, onChange = _a.onChange;
    var intl = useIntl();
    return (React.createElement(Select, { "aria-label": intl.formatMessage({
            id: 'ui-calendar.calendarForm.openings.column.status'
        }), required: true, fullWidth: true, marginBottom0: true, dataOptions: [
            {
                value: RowType.Open,
                label: intl.formatMessage({
                    id: 'ui-calendar.calendarForm.openClosedSelect.open'
                })
            },
            {
                value: RowType.Closed,
                label: intl.formatMessage({
                    id: 'ui-calendar.calendarForm.openClosedSelect.closed'
                })
            }
        ], value: value, onInput: function (e) {
            var newType = e.target.value;
            var newProps = {
                type: newType
            };
            onChange(newProps);
            onBlur();
        } }));
}
